import React, { useContext, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useIntegratorGetRedirectUrl } from "../../hooks/integrator";
import { useQueryParams } from "../../hooks/queryParams";
import { Loading } from "../../components";
import { AuthContext } from "src/contexts/AuthContext";

type Params = {
  providerId: string;
};

const ProviderRedirect = () => {
  const { authenticate } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const { providerId } = useParams<Params>() as Params;
  const queryParams = useQueryParams();
  const code = queryParams.get("code") || "";
  const state = queryParams.get("state") || "";

  const { response, error } = useIntegratorGetRedirectUrl(
    code,
    state,
    providerId
  );

  if (error) {
    return <Navigate to="/error?error_code=100" />;
  }

  if (response.redirectUrl) {
    window.location.href = response.redirectUrl;
    return null;
  }

  return <Loading />;
};

export default ProviderRedirect;
